import * as ReactDOM from 'react-dom/client';

import App from './app/app';

import { initOpenAIPixel } from '@frontend/sorghum/utils';
import { BrowserRouter } from 'react-router-dom';
import { environment } from './environments/environment';

// OpenAI Ads pixel 在 React 掛載前就注入：SDK 要從落地網址讀 oppref 歸因參數，越早開始載越不會
// 被路由導向吃掉；也避免在元件 render 階段做副作用。無 pixel ID 的環境（SIT / PREL）不注入。
// 與 GTM 的 OpenAI tag 只能擇一啟用，否則轉換會重複上報。
initOpenAIPixel(environment.openaiAdsPixelId);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
